const re = {
  CHINESE: /[\u3400-\u9FBF]/,
};

export const checkLocale = (string) => {
  const reg = re.CHINESE;
  const isChina = reg.test(string);
  return isChina;
};
